<app-basic-page [pageTitle]="'Scenario Library'">
  <app-primary-button
    class="header-right start-new-call"
    [icon]="'add'"
    [text]="'Add Scenario'"
    (click)="onStartNewCallClick()"
  ></app-primary-button>
  <div class="vertical-large">
    <app-sales-cycle-bar></app-sales-cycle-bar>
    <div class="profile-card-grid margin-top">
      @for (item of filteredSessionTemplateList(); track $index) {
        <app-session-template-card [sessionTemplate]="item" [editable]="true"> </app-session-template-card>
      }
    </div>
  </div>
</app-basic-page>

<app-new-edit-session-template
  [isEdit]="false"
  [(isVisible)]="isSessionTemplateVisible"
></app-new-edit-session-template>

<app-new-survey-session-template [(isVisible)]="isNewSessionTemplateVisible"></app-new-survey-session-template>
